import { useDentalInsuranceReportContext } from '../../..';
import { NETWORK_KEY_MAPPINGS_BY_VENDOR } from '../../../../helpers/formattedDentalCoverageTableData';
import { useInsuranceEligibilityReportContainerContext } from '../../../../providers/insurance-report-container.provider';
import { InsuranceReportTable, useInsuranceReportAccordionContext } from '../../../../shared';
import { useInsuranceTableColumnFilters } from '../../hooks/useInsuranceTableColumnFilters';
import { useInsuranceTableFilters } from '../../hooks/useInsuranceTableFilters';
import { TableDataType, TableFilterKey, Vendors } from '../../types/types';
import { InsuranceReportPrintableAccordionSection } from './InsuranceReportPrintableAccordionSection';
import { InsuranceSectionFilterContainer } from './InsuranceSectionFilterContainer';

export const LimitationsTable = () => {
  const { locationId } = useInsuranceEligibilityReportContainerContext();
  const { tablesData, vendor } = useDentalInsuranceReportContext();
  const { isPrintReport } = useInsuranceReportAccordionContext();
  //This config is specifically for tuuthfairy as the last table is limitations in tuuthfairy and pradeep explicitly wanted to have it for demo
  const defaultNumberOfRowsPerPage = vendor === Vendors.TuuthFairy ? 40 : 10;
  const {
    InsuranceTableFilterSwitchComponent: InsuranceTableNetworkFilterSwitchComponent,
    filteredDataByFilterValue: filteredData,
  } = useInsuranceTableFilters({
    key: NETWORK_KEY_MAPPINGS_BY_VENDOR[vendor as Vendors]['networkName'] as TableFilterKey,
    tableId: 'limitation',
    tableData: tablesData.limitation || [],
    enabled: vendor === Vendors.TuuthFairy,
  });
  const { tableColumnsList, InsuranceReportTableColumnFilter } = useInsuranceTableColumnFilters({
    tableId: 'limitation',
    isPrintReport,
    locationId,
  });

  if (isPrintReport) {
    return (
      <InsuranceReportPrintableAccordionSection
        tableId='limitation'
        columns={tableColumnsList}
        vendor={vendor as Vendors}
      />
    );
  }

  return (
    <>
      <InsuranceSectionFilterContainer>
        {InsuranceTableNetworkFilterSwitchComponent}
        {InsuranceReportTableColumnFilter}
      </InsuranceSectionFilterContainer>
      <InsuranceReportTable<TableDataType>
        tableInstanceId={`insurance-report-limitations`}
        columns={tableColumnsList}
        tableData={filteredData || []}
        isPaginated={!isPrintReport}
        defaultRowsPerPage={defaultNumberOfRowsPerPage}
      />
    </>
  );
};
